export default class UniqueSellingPoint {
  constructor(
    id: number,
    header: string,
    description: string,
    image: string
  ) {
    this.id = id;
    this.header = header;
    this.description = description;
    this.image = image;
  }

  public id: number;

  public header: string;

  public description: string;

  public image: string;
}
